import styled from 'styled-components';

export interface HealthMachineDetailStyleProps {
  open: boolean;
}

export const HealthMachineDetailStyled = styled.div<HealthMachineDetailStyleProps>`
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background: #fff;
  transition: all 0.25s ease-in-out;

  ${props =>
    props.open
      ? `
    left: 0;
    opacity: 1;
    visibility: visible;
  `
      : `
    left: 100%;
    opacity: 1;
    visibility: hidden;
  `}

  .image {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 12;
    background: #ededed;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .close-button {
      position: absolute;
      right: ${props => props.theme.size.rap};
      top: ${props => props.theme.size.rap};
      background: none;
      border: none;
      font-size: 1.2rem;
      cursor: pointer;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    padding: ${props => props.theme.size.rap};
    flex: 1;

    .title {
      margin-bottom: 1rem;
    }

    .health-form {
      display: flex;
      align-items: center;
      gap: 1rem;
      margin-bottom: 1rem;

      .form-wrap {
        display: flex;
        align-items: center;
        width: 50%;
        gap: 0.5rem;

        .label {
          font-size: 1.2rem;
          font-weight: bold;
        }

        .input {
          flex: 1;
          input {
            width: 100%;
            border: none;
            background: #f2f4f8;
            border-radius: 0.2rem;
            font-size: 1.4rem;
            padding: 0.5rem 1rem;
            text-align: right;
          }
        }
      }
    }

    .action-button {
      margin-top: 2rem;

      .Button {
        height: 2.6rem;
        margin-bottom: 0.4rem;
        font-size: 1.05rem;
      }
    }
  }
`;
